/**
 * Template per i secrets dell'applicazione.
 *
 * COPIA QUESTO FILE in `secrets.ts` (gitignored) e compila i valori reali
 * prima del primo `ng serve` / `ng build`.
 *
 * In CI/CD, il file `secrets.ts` viene generato dal pipeline a partire
 * dalle variabili d'ambiente GitLab (CLIENT_TOKEN, KENDO_UI_LICENSE_KEY,
 * ecc.) e non viene mai committato.
 *
 * NON aggiungere mai valori reali a questo file. Solo placeholder.
 */
export const SECRETS = {
  /** Token client usato per chiamate inter-servizio agente/cliente. */
  CLIENT_TOKEN:
    'yxaPEEo1tI3N2nL39IQKnUl1OEWowCeTX9fjVl5seUnl+SJmNTYF1I2c7aawXqznI8xcw0vU2SNy4bZPVmKAhYCTjxCoyooXbDnesATP+zlbNZnaEQDqweiwAvNtdbPxA4V3scJQXQ+JjnPQH09oz4yMhN99DGuw6+GHMWoKc5w=',
};
